export default __webpack_public_path__ + "static/media/kibana.b6ce9b8f.svg";